// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppWidget from './components/WhatsAppWidget';

// Import pages
import Home from './pages/Home';
import About from './pages/About';
import Personal from './pages/Personal';
import Business from './pages/Business';
import Loans from './pages/Loans';
import Careers from './pages/Careers';
import HelpCentre from './pages/HelpCentre';
import PrivacyPolicy from './pages/PrivacyPolicy';
import OnlineBanking from './pages/OnlineBanking';

// Import theme
import theme from './theme/theme';

// Import global styles
import GlobalStyles from './GlobalStyles';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/personal" element={<Personal />} />
              <Route path="/business" element={<Business />} />
              <Route path="/loans" element={<Loans />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/help-centre" element={<HelpCentre />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/online-banking" element={<OnlineBanking />} />
              {/* Add more routes as needed */}
            </Routes>
          </Box>
          <Footer />
          <WhatsAppWidget />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;